import React, { useRef, useState } from "react";
import "./PlansBilling.css";
import { FiCheck } from "react-icons/fi";
import AddOnsSection from "./AddOnsSection";
const plans = [
  {
    id: "starter",
    title: "Starter",
    price: "$11",
    priceNote: "per month billed annually",
    monthly: "$14 billed monthly",
    description: "Start crafting better customer experiences",
    features: [
      "1 chatbot",
      "10M Upload Characters",
      "Access to GPT-4o mini AI model",
      "3 agentic actions",
      "Lead capture forms",
      "Upload sitemaps with up to 5,000 URLs"
    ],
    cta: "Select this plan",
  },
  {
    id: "pro",
    title: "Professional",
    price: "$30",
    priceNote: "per month billed annually",
    monthly: "$37 billed monthly",
    description: "Comprehensive AI agents to scale self-service",
    features: [
      "2 chatbots",
      "50M Upload Characters",
      "Access to GPT-4 and upcoming AI models",
      "5 agentic actions",
      "Lead capture forms",
      "Upload sitemaps with up to 5,000 URLs",
      "Automated email transcripts",
      "Request callback button"
    ],
    cta: "Select this plan",

  },
  {
    id: "advanced",
    title: "Advanced",
    price: "$179",
    priceNote: "per month billed annually",
    monthly: "$224 billed monthly",
    description:
      "Comprehensive agentic workflows to scale self-service and automate tasks",
    features: [
      "5 chatbots",
      "100M Upload Characters",
      "Create industry-specific workflows with AI agents that reason and execute tasks automatically.",
      "Up to 5 agentic workflows and 10 actions (per bot)",
      "No limit on sitemap size",
      "Auto-sync from your website and 3rd party platforms",
      "1 training session",
      "Dedicated Slack channel for 1 month (optional)",
      "API Access"
    ],
    cta: "Select this plan",
  },
  {
    id: "enterprise",
    title: "Enterprise",
    price: "Custom Pricing",
    description:
      "Our most powerful AI agents for advanced workflows and flexibility",
    features: [
      "Custom number of chatbots",
      "Custom number of upload characters",
      "Create industry-specific workflows with AI agents that reason and execute tasks automatically.",
      "Custom number of workflows and actions",
      "Advanced branding",
      "Advanced AI analytics",
      "SSO/SAML login",
      "Training sessions",
      "Priority Support",
      "Dedicated Slack channel for direct support",
      "Invoicing options",
      "API Access",
      "Audit log"
    ],
    cta: "Talk to sales",

  },
];

export default function PlansBilling({ currentPlan }) {
  const [activePlan, setActivePlan] = useState("pro"); // default tab in AddOns
  const addonsRef = useRef(null);

  const handlePlanSelect = (planId) => {
    // Set the selected plan in AddOns tabs
    setActivePlan(planId);

    // Smooth scroll to AddOns section
    if (addonsRef.current) {
      addonsRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };
  return (
    <div className="plans-container">
      <h1 className="plans-title">Plans and Billing</h1>

      {/* Current Plan */}
      <section className="current-plan">
        {currentPlan?.planId === "none" ? (
          <p className="no-plan">No plan selected currently.</p>
        ) : (
          <div className="plan-card current">
            <h2>
              Current Plan:{" "}
              <span className="highlight">
                {currentPlan.planId === "starter" ? "Starter" :
                 currentPlan.planId === "pro" ? "Professional" :
                 currentPlan.planId === "advanced" ? "Advanced" :
                 currentPlan.planId === "enterprise" ? "Enterprise" :
                 currentPlan.planId}
              </span>
            </h2>
            <p>
              Chatbot: {currentPlan.chatbotsUsed}/{currentPlan.chatbotLimit}
            </p>
            <p>
              Character Used:{" "}
              {(currentPlan.charsUsed / 1000).toFixed(0)}K /
              {(currentPlan.charLimit / 1_000_000).toFixed(0)}M
            </p>
          </div>
        )}
      </section>

      {/* Upgrade Plans */}
      <section>
        <h2 className="upgrade-title">Upgrade your plan</h2>
        <div className="plans-grid">
          {plans.map((plan) => (
            <div
              key={plan.id}
              className={`plan-card ${plan.highlight ? "highlighted" : ""}`}
            >
              <div className="plan-header">
                <h3>{plan.title}</h3>
                <p className="plan-desc">{plan.description}</p>
                <p className="plan-price">{plan.price}</p>
                {plan.priceNote && (
                  <p className="plan-note">{plan.priceNote}</p>
                )}
                {plan.monthly && <p className="plan-note">{plan.monthly}</p>}
              </div>
              <ul className="plan-features">
                {plan.features.map((f, i) => (
                  <li key={i}>
                    <FiCheck /> {f}
                  </li>
                ))}
              </ul>
              <button
                className={`plan-cta ${plan.disabled ? "disabled" : ""}`}
                disabled={plan.disabled}
                onClick={() => handlePlanSelect(plan.id)}
              >
                {plan.cta}
              </button>
            </div>
          ))}
        </div>
      </section>

      <section ref={addonsRef} id="addons-section">
        <AddOnsSection
          activePlan={activePlan} // 'starter' | 'pro' | 'advanced'
          onChangePlan={setActivePlan}
          currentPlan={{
            planId: currentPlan?.planId || "",
            status: currentPlan?.status,
            email: currentPlan?.email
          }}
          onContinue={(payload) => {
            console.log("Selected billing payload:", payload);
          }}
        />
      </section>
    </div>
  );
}
